import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  chef: false,
  dishes: false,
  dishMenuCategoryCardDetails: false,
  cart: false,
  account: false,
  profile: false,
  explore: true,
  faq: false,
  about: false,
  storie: false,
  underconstruction: false,
  dishclick: false,
  checkout: false,
  isOrderSucessfull: false,
  benefits: false,
  dishBook: false,
  orderReviewWrite: false,
  legalView: false,
  isEditUserDetail: false,
  bottombardisplay: true,
  locationSelector: false,
  location: false,
  address: false,
  addressForm: false,
  tracking: false,
  orderSummary: false,
  menu: false,
  bannerInfo: false,
  from: "",
  helpChatScreen: false,
  chefListScreen: false,
  hostScreen: false,
};

const bottomBarSlice = createSlice({
  name: "bottomBar",
  initialState,
  reducers: {
    loadTab(state, action) {
      switch (action.payload.tabName) {
        case "chef":
          state.bannerInfo = false;
          state.chef = true;
          state.menu = false;
          state.dishes = false;
          state.dishMenuCategoryCardDetails = false;
          state.cart = false;
          state.profile = false;
          state.explore = false;
          state.faq = false;
          state.about = false;
          state.account = false;
          state.storie = false;
          state.dishclick = false;
          state.checkout = false;
          state.isOrderSucessfull = false;
          state.benefits = false;
          state.dishBook = false;
          state.orderReviewWrite = false;
          state.legalView = false;
          state.isEditUserDetail = false;
          state.bottombardisplay = true;
          state.locationSelector = false;
          state.location = false;
          state.address = false;
          state.addressForm = false;
          state.tracking = false;
          state.orderSummary = false;
          state.orderDetailsPage = false;
          state.helpChatScreen = false;
          state.chefListScreen = false;
          state.hostScreen = false;
          break;
        case "dishes":
          state.bannerInfo = false;
          state.dishes = true;
          state.menu = false;
          state.dishMenuCategoryCardDetails = false;
          state.chef = false;
          state.cart = false;
          state.storie = false;
          state.profile = false;
          state.explore = false;
          state.faq = false;
          state.about = false;
          state.account = false;
          state.dishclick = true;
          state.checkout = false;
          state.isOrderSucessfull = false;
          state.benefits = false;
          state.dishBook = false;
          state.orderReviewWrite = false;
          state.legalView = false;
          state.isEditUserDetail = false;
          state.bottombardisplay = true;
          state.locationSelector = false;
          state.location = false;
          state.address = false;
          state.addressForm = false;
          state.tracking = false;
          state.orderSummary = false;
          state.orderDetailsPage = false;
          state.helpChatScreen = false;
          state.chefListScreen = false;
          state.hostScreen = false;
          break;
          case "explore":
            state.bannerInfo = false;
            state.dishes = false;
            state.menu = false;
            state.dishMenuCategoryCardDetails = false;
            state.chef = false;
            state.cart = false;
            state.storie = false;
            state.profile = false;
            state.explore = true;
            state.faq = false;
            state.about = false;
            state.account = false;
            state.dishclick = true;
            state.checkout = false;
            state.isOrderSucessfull = false;
            state.benefits = false;
            state.dishBook = false;
            state.orderReviewWrite = false;
            state.legalView = false;
            state.isEditUserDetail = false;
            state.bottombardisplay = true;
            state.locationSelector = false;
            state.location = false;
            state.address = false;
            state.addressForm = false;
            state.tracking = false;
            state.orderSummary = false;
            state.orderDetailsPage = false;
            state.helpChatScreen = false;
            state.chefListScreen = false;
            state.hostScreen = false;
            break;
        case "dishMenuCategoryCardDetails":
          state.bannerInfo = false;
          state.dishes = false;
          state.menu = false;
          state.dishMenuCategoryCardDetails = true;
          state.chef = false;
          state.cart = false;
          state.storie = false;
          state.profile = false;
          state.explore = false;
          state.faq = false;
          state.about = false;
          state.account = false;
          state.dishclick = true;
          state.checkout = false;
          state.isOrderSucessfull = false;
          state.benefits = false;
          state.dishBook = false;
          state.orderReviewWrite = false;
          state.legalView = false;
          state.isEditUserDetail = false;
          state.bottombardisplay = true;
          state.locationSelector = false;
          state.location = false;
          state.address = false;
          state.addressForm = false;
          state.tracking = false;
          state.orderSummary = false;
          state.orderDetailsPage = false;
          state.helpChatScreen = false;
          state.chefListScreen = false;
          state.hostScreen = false;
          break;
        case "cart":
          state.bannerInfo = false;
          state.cart = true;
          state.menu = false;
          state.chef = false;
          state.dishes = false;
          state.dishMenuCategoryCardDetails = false;
          state.profile = false;
          state.explore = false;
          state.faq = false;
          state.about = false;
          state.storie = false;
          state.account = false;
          state.dishclick = false;
          state.checkout = false;
          state.isOrderSucessfull = false;
          state.benefits = false;
          state.dishBook = false;
          state.orderReviewWrite = false;
          state.legalView = false;
          state.isEditUserDetail = false;
          state.bottombardisplay = true;
          state.locationSelector = false;
          state.location = false;
          state.address = false;
          state.addressForm = false;
          state.tracking = false;
          state.orderSummary = false;
          state.orderDetailsPage = false;
          state.helpChatScreen = false;
          state.chefListScreen = false;
          state.hostScreen = false;
          break;
        case "checkout":
          state.bannerInfo = false;
          state.checkout = true;
          state.menu = false;
          state.isOrderSucessfull = false;
          state.cart = false;
          state.chef = false;
          state.dishes = false;
          state.dishMenuCategoryCardDetails = false;
          state.profile = false;
          state.explore = false;
          state.faq = false;
          state.about = false;
          state.storie = false;
          state.account = false;
          state.dishclick = false;
          state.benefits = false;
          state.dishBook = false;
          state.orderReviewWrite = false;
          state.legalView = false;
          state.isEditUserDetail = false;
          state.bottombardisplay = true;
          state.locationSelector = false;
          state.location = false;
          state.address = false;
          state.addressForm = false;
          state.tracking = false;
          state.orderSummary = false;
          state.orderDetailsPage = false;
          state.helpChatScreen = false;
          state.chefListScreen = false;
          state.hostScreen = false;
          break;
        case "orderSucessfull":
          state.bannerInfo = false;
          state.checkout = false;
          state.menu = false;
          state.isOrderSucessfull = true;
          state.cart = false;
          state.chef = false;
          state.dishes = false;
          state.dishMenuCategoryCardDetails = false;
          state.profile = false;
          state.explore = false;
          state.faq = false;
          state.about = false;
          state.storie = false;
          state.account = false;
          state.dishclick = false;
          state.benefits = false;
          state.dishBook = false;
          state.orderReviewWrite = false;
          state.legalView = false;
          state.isEditUserDetail = false;
          state.bottombardisplay = true;
          state.locationSelector = false;
          state.location = false;
          state.address = false;
          state.addressForm = false;
          state.tracking = false;
          state.orderSummary = false;
          state.orderDetailsPage = false;
          state.helpChatScreen = false;
          state.chefListScreen = false;
          state.hostScreen = false;
          break;
        case "account":
          state.bannerInfo = false;
          state.account = true;
          state.menu = false;
          state.chef = false;
          state.dishes = false;
          state.dishMenuCategoryCardDetails = false;
          state.cart = false;
          state.profile = false;
          state.explore = false;
          state.faq = false;
          state.about = false;
          state.storie = false;
          state.dishclick = false;
          state.checkout = false;
          state.isOrderSucessfull = false;
          state.benefits = false;
          state.dishBook = false;
          state.orderReviewWrite = false;
          state.legalView = false;
          state.isEditUserDetail = false;
          state.bottombardisplay = true;
          state.locationSelector = false;
          state.location = false;
          state.address = false;
          state.addressForm = false;
          state.tracking = false;
          state.orderSummary = false;
          state.orderDetailsPage = false;
          state.helpChatScreen = false;
          state.chefListScreen = false;
          state.hostScreen = false;
          break;
        case "benefits":
          state.bannerInfo = false;
          state.benefits = true;
          state.account = false;
          state.menu = false;
          state.chef = false;
          state.dishes = false;
          state.dishMenuCategoryCardDetails = false;
          state.cart = false;
          state.profile = false;
          state.explore = false;
          state.faq = false;
          state.about = false;
          state.storie = false;
          state.dishclick = false;
          state.checkout = false;
          state.isOrderSucessfull = false;
          state.dishBook = false;
          state.orderReviewWrite = false;
          state.legalView = false;
          state.isEditUserDetail = false;
          state.locationSelector = false;
          state.location = false;
          state.address = false;
          state.addressForm = false;
          state.tracking = false;
          state.orderSummary = false;
          state.orderDetailsPage = false;
          state.helpChatScreen = false;
          state.chefListScreen = false;
          state.hostScreen = false;
          break;
        case "profile":
          state.bannerInfo = false;
          state.profile = true;
          state.explore = false;
          state.faq = false;
          state.menu = false;
          state.about = false;
          state.chef = false;
          state.storie = false;
          state.dishes = false;
          state.dishMenuCategoryCardDetails = false;
          state.cart = false;
          state.account = false;
          state.dishclick = false;
          state.checkout = false;
          state.isOrderSucessfull = false;
          state.benefits = false;
          state.dishBook = false;
          state.orderReviewWrite = false;
          state.legalView = false;
          state.isEditUserDetail = false;
          state.bottombardisplay = true;
          state.locationSelector = false;
          state.location = false;
          state.address = false;
          state.addressForm = false;
          state.tracking = false;
          state.orderSummary = false;
          state.orderDetailsPage = false;
          state.helpChatScreen = false;
          state.chefListScreen = false;
          state.hostScreen = false;
          break;
        case "faq":
          state.bannerInfo = false;
          state.faq = true;
          state.storie = false;
          state.menu = false;
          state.account = false;
          state.profile = false;
          state.explore = false;
          state.about = false;
          state.checkout = false;
          state.isOrderSucessfull = false;
          state.benefits = false;
          state.dishBook = false;
          state.orderReviewWrite = false;
          state.legalView = false;
          state.dishes = false;
          state.dishMenuCategoryCardDetails = false;
          state.cart = false;
          state.dishclick = false;
          state.chef = false;
          state.isEditUserDetail = false;
          state.bottombardisplay = true;
          state.locationSelector = false;
          state.location = false;
          state.address = false;
          state.addressForm = false;
          state.tracking = false;
          state.orderSummary = false;
          state.orderDetailsPage = false;
          state.helpChatScreen = false;
          state.chefListScreen = false;
          state.hostScreen = false;
          break;
        case "about":
          state.bannerInfo = false;
          state.faq = false;
          state.menu = false;
          state.storie = false;
          state.account = false;
          state.profile = false;
          state.explore = false;
          state.about = true;
          state.checkout = false;
          state.isOrderSucessfull = false;
          state.benefits = false;
          state.dishBook = false;
          state.orderReviewWrite = false;
          state.legalView = false;
          state.dishes = false;
          state.dishMenuCategoryCardDetails = false;
          state.cart = false;
          state.dishclick = false;
          state.chef = false;
          state.isEditUserDetail = false;
          state.bottombardisplay = true;
          state.locationSelector = false;
          state.location = false;
          state.address = false;
          state.addressForm = false;
          state.tracking = false;
          state.orderSummary = false;
          state.orderDetailsPage = false;
          state.helpChatScreen = false;
          state.chefListScreen = false;
          state.hostScreen = false;
          break;
        case "storie":
          state.bannerInfo = false;
          state.storie = true;
          state.menu = true;
          state.account = false;
          state.profile = false;
          state.explore = false;
          state.faq = false;
          state.about = false;
          state.checkout = false;
          state.isOrderSucessfull = false;
          state.benefits = false;
          state.dishBook = false;
          state.orderReviewWrite = false;
          state.legalView = false;
          state.dishes = false;
          state.dishMenuCategoryCardDetails = false;
          state.cart = false;
          state.dishclick = false;
          state.chef = false;
          state.isEditUserDetail = false;
          state.bottombardisplay = true;
          state.locationSelector = false;
          state.location = false;
          state.address = false;
          state.addressForm = false;
          state.tracking = false;
          state.orderSummary = false;
          state.orderDetailsPage = false;
          state.helpChatScreen = false;
          state.chefListScreen = false;
          state.hostScreen = false;
          break;
        case "dishBook":
          state.bannerInfo = false;
          state.dishBook = true;
          state.legalView = false;
          state.orderReviewWrite = false;
          state.menu = false;
          state.cart = false;
          state.chef = false;
          state.dishes = false;
          state.dishMenuCategoryCardDetails = false;
          state.profile = false;
          state.explore = false;
          state.faq = false;
          state.about = false;
          state.storie = false;
          state.account = false;
          state.dishclick = false;
          state.checkout = false;
          state.isOrderSucessfull = false;
          state.benefits = false;
          state.isEditUserDetail = false;
          state.bottombardisplay = true;
          state.locationSelector = false;
          state.location = false;
          state.address = false;
          state.addressForm = false;
          state.tracking = false;
          state.orderSummary = false;
          state.orderDetailsPage = false;
          state.helpChatScreen = false;
          state.chefListScreen = false;
          state.hostScreen = false;
          break;
          case "orderReviewWrite":
          state.bannerInfo = false;
          state.dishBook = false;
          state.orderReviewWrite = true;
          state.legalView = false;
          state.menu = false;
          state.cart = false;
          state.chef = false;
          state.dishes = false;
          state.dishMenuCategoryCardDetails = false;
          state.profile = false;
          state.explore = false;
          state.faq = false;
          state.about = false;
          state.storie = false;
          state.account = false;
          state.dishclick = false;
          state.checkout = false;
          state.isOrderSucessfull = false;
          state.benefits = false;
          state.isEditUserDetail = false;
          state.bottombardisplay = true;
          state.locationSelector = false;
          state.location = false;
          state.address = false;
          state.addressForm = false;
          state.tracking = false;
          state.orderSummary = false;
          state.orderDetailsPage = false;
          state.helpChatScreen = false;
          state.chefListScreen = false;
          state.hostScreen = false;
          break;
        case "legalView":
          state.bannerInfo = false;
          state.dishBook = false;
          state.orderReviewWrite = false;
          state.legalView = true;
          state.menu = false;
          state.cart = false;
          state.chef = false;
          state.dishes = false;
          state.dishMenuCategoryCardDetails = false;
          state.profile = false;
          state.explore = false;
          state.faq = false;
          state.about = false;
          state.storie = false;
          state.account = false;
          state.dishclick = false;
          state.checkout = false;
          state.isOrderSucessfull = false;
          state.benefits = false;
          state.isEditUserDetail = false;
          state.bottombardisplay = true;
          state.locationSelector = false;
          state.location = false;
          state.address = false;
          state.addressForm = false;
          state.tracking = false;
          state.orderSummary = false;
          state.orderDetailsPage = false;
          state.helpChatScreen = false;
          state.chefListScreen = false;
          state.hostScreen = false;
          break;
        case "editUser":
          state.bannerInfo = false;
          state.isEditUserDetail = true;
          state.menu = false;
          state.dishBook = false;
          state.orderReviewWrite = false;
          state.legalView = false;
          state.cart = false;
          state.chef = false;
          state.dishes = false;
          state.dishMenuCategoryCardDetails = false;
          state.profile = false;
          state.explore = false;
          state.faq = false;
          state.about = false;
          state.storie = false;
          state.account = false;
          state.dishclick = false;
          state.checkout = false;
          state.isOrderSucessfull = false;
          state.benefits = false;
          state.bottombardisplay = true;
          state.locationSelector = false;
          state.location = false;
          state.address = false;
          state.addressForm = false;
          state.tracking = false;
          state.orderSummary = false;
          state.orderDetailsPage = false;
          state.helpChatScreen = false;
          state.chefListScreen = false;
          state.hostScreen = false;
          break;

        case "locationSelector":
          state.bannerInfo = false;
          state.locationSelector = true;
          state.menu = false;
          state.isEditUserDetail = false;
          state.dishBook = false;
          state.orderReviewWrite = false;
          state.legalView = false;
          state.cart = false;
          state.chef = false;
          state.dishes = false;
          state.dishMenuCategoryCardDetails = false;
          state.profile = false;
          state.explore = false;
          state.faq = false;
          state.about = false;
          state.storie = false;
          state.account = false;
          state.dishclick = false;
          state.checkout = false;
          state.isOrderSucessfull = false;
          state.benefits = false;
          state.bottombardisplay = true;
          state.location = false;
          state.address = false;
          state.addressForm = false;
          state.tracking = false;
          state.orderSummary = false;
          state.orderDetailsPage = false;
          state.helpChatScreen = false;
          state.chefListScreen = false;
          state.hostScreen = false;
          break;

        case "location":
          state.bannerInfo = false;
          state.location = true;
          state.menu = false;
          state.isEditUserDetail = false;
          state.dishBook = false;
          state.orderReviewWrite = false;
          state.legalView = false;
          state.cart = false;
          state.chef = false;
          state.dishes = false;
          state.dishMenuCategoryCardDetails = false;
          state.profile = false;
          state.explore = false;
          state.faq = false;
          state.about = false;
          state.storie = false;
          state.account = false;
          state.dishclick = false;
          state.checkout = false;
          state.isOrderSucessfull = false;
          state.benefits = false;
          state.bottombardisplay = false;
          state.address = false;
          state.addressForm = false;
          state.locationSelector = false;
          state.tracking = false;
          state.orderSummary = false;
          state.orderDetailsPage = false;
          state.helpChatScreen = false;
          state.chefListScreen = false;
          state.hostScreen = false;
          break;

        case "address":
          state.bannerInfo = false;
          state.address = true;
          state.menu = false;
          state.location = false;
          state.isEditUserDetail = false;
          state.dishBook = false;
          state.orderReviewWrite = false;
          state.legalView = false;
          state.cart = false;
          state.chef = false;
          state.dishes = false;
          state.dishMenuCategoryCardDetails = false;
          state.profile = false;
          state.explore = false;
          state.faq = false;
          state.about = false;
          state.storie = false;
          state.account = false;
          state.dishclick = false;
          state.checkout = false;
          state.isOrderSucessfull = false;
          state.benefits = false;
          state.bottombardisplay = false;
          state.addressForm = false;
          state.locationSelector = false;
          state.tracking = false;
          state.orderSummary = false;
          state.orderDetailsPage = false;
          state.helpChatScreen = false;
          state.chefListScreen = false;
          state.hostScreen = false;
          break;

        case "addressForm":
          state.bannerInfo = false;
          state.addressForm = true;
          state.menu = false;
          state.location = false;
          state.isEditUserDetail = false;
          state.dishBook = false;
          state.orderReviewWrite = false;
          state.legalView = false;
          state.cart = false;
          state.chef = false;
          state.dishes = false;
          state.dishMenuCategoryCardDetails = false;
          state.profile = false;
          state.explore = false;
          state.faq = false;
          state.about = false;
          state.storie = false;
          state.account = false;
          state.dishclick = false;
          state.checkout = false;
          state.isOrderSucessfull = false;
          state.benefits = false;
          state.bottombardisplay = false;
          state.address = false;
          state.locationSelector = false;
          state.tracking = false;
          state.orderSummary = false;
          state.orderDetailsPage = false;
          state.helpChatScreen = false;
          state.chefListScreen = false;
          state.hostScreen = false;
          break;

        case "tracking":
          state.bannerInfo = false;
          state.tracking = true;
          state.menu = false;
          state.addressForm = false;
          state.location = false;
          state.isEditUserDetail = false;
          state.dishBook = false;
          state.orderReviewWrite = false;
          state.legalView = false;
          state.cart = false;
          state.chef = false;
          state.dishes = false;
          state.dishMenuCategoryCardDetails = false;
          state.profile = false;
          state.explore = false;
          state.faq = false;
          state.about = false;
          state.storie = false;
          state.account = false;
          state.dishclick = false;
          state.checkout = false;
          state.isOrderSucessfull = false;
          state.benefits = false;
          state.bottombardisplay = false;
          state.address = false;
          state.locationSelector = false;
          state.orderSummary = false;
          state.orderDetailsPage = false;
          state.helpChatScreen = false;
          state.chefListScreen = false;
          state.hostScreen = false;

        case "orderSummary":
          state.bannerInfo = false;
          state.orderSummary = true;
          state.orderDetailsPage = false;
          state.menu = false;
          state.tracking = false;
          state.addressForm = false;
          state.location = false;
          state.isEditUserDetail = false;
          state.dishBook = false;
          state.orderReviewWrite = false;
          state.legalView = false;
          state.cart = false;
          state.chef = false;
          state.dishes = false;
          state.dishMenuCategoryCardDetails = false;
          state.profile = false;
          state.explore = false;
          state.faq = false;
          state.about = false;
          state.storie = false;
          state.account = false;
          state.dishclick = false;
          state.checkout = false;
          state.isOrderSucessfull = false;
          state.benefits = false;
          state.bottombardisplay = true;
          state.address = false;
          state.locationSelector = false;
          state.helpChatScreen = false;
          state.chefListScreen = false;
          state.hostScreen = false;
          break;
        case "orderDetailsPage":
          state.bannerInfo = false;
          state.orderSummary = false;
          state.orderDetailsPage = true;
          state.menu = false;
          state.tracking = false;
          state.addressForm = false;
          state.location = false;
          state.isEditUserDetail = false;
          state.dishBook = false;
          state.orderReviewWrite = false;
          state.legalView = false;
          state.cart = false;
          state.chef = false;
          state.dishes = false;
          state.dishMenuCategoryCardDetails = false;
          state.profile = false;
          state.explore = false;
          state.faq = false;
          state.about = false;
          state.storie = false;
          state.account = false;
          state.dishclick = false;
          state.checkout = false;
          state.isOrderSucessfull = false;
          state.benefits = false;
          state.bottombardisplay = true;
          state.address = false;
          state.locationSelector = false;
          state.helpChatScreen = false;
          state.chefListScreen = false;
          state.hostScreen = false;
          break;

        case "menu":
          state.bannerInfo = false;
          state.menu = true;
          state.orderSummary = false;
          state.orderDetailsPage = false;
          state.tracking = false;
          state.addressForm = false;
          state.location = false;
          state.isEditUserDetail = false;
          state.dishBook = false;
          state.orderReviewWrite = false;
          state.legalView = false;
          state.cart = false;
          state.chef = false;
          state.dishes = false;
          state.dishMenuCategoryCardDetails = false;
          state.profile = false;
          state.explore = false;
          state.faq = false;
          state.about = false;
          state.storie = false;
          state.account = false;
          state.dishclick = false;
          state.checkout = false;
          state.isOrderSucessfull = false;
          state.benefits = false;
          state.bottombardisplay = true;
          state.address = false;
          state.locationSelector = false;
          state.helpChatScreen = false;
          state.chefListScreen = false;
          state.hostScreen = false;
          break;

        case "bannerInfo":
          state.bannerInfo = true;
          state.menu = false;
          state.orderSummary = false;
          state.orderDetailsPage = false;
          state.tracking = false;
          state.addressForm = false;
          state.location = false;
          state.isEditUserDetail = false;
          state.dishBook = false;
          state.orderReviewWrite = false;
          state.legalView = false;
          state.cart = false;
          state.chef = false;
          state.dishes = false;
          state.dishMenuCategoryCardDetails = false;
          state.profile = false;
          state.explore = false;
          state.faq = false;
          state.about = false;
          state.storie = false;
          state.account = false;
          state.dishclick = false;
          state.checkout = false;
          state.isOrderSucessfull = false;
          state.benefits = false;
          state.bottombardisplay = true;
          state.address = false;
          state.locationSelector = false;
          state.helpChatScreen = false;
          state.chefListScreen = false;
          state.hostScreen = false;
          break;
        case "helpChatScreen":
          state.bannerInfo = false;
          state.menu = false;
          state.orderSummary = false;
          state.orderDetailsPage = false;
          state.tracking = false;
          state.addressForm = false;
          state.location = false;
          state.isEditUserDetail = false;
          state.dishBook = false;
          state.orderReviewWrite = false;
          state.legalView = false;
          state.cart = false;
          state.chef = false;
          state.dishes = false;
          state.dishMenuCategoryCardDetails = false;
          state.profile = false;
          state.explore = false;
          state.faq = false;
          state.about = false;
          state.storie = false;
          state.account = false;
          state.dishclick = false;
          state.checkout = false;
          state.isOrderSucessfull = false;
          state.benefits = false;
          state.bottombardisplay = true;
          state.address = false;
          state.locationSelector = false;
          state.helpChatScreen = true;
          state.chefListScreen = false;
          state.hostScreen = false;
          break;

        case "chefListScreen":
          state.bannerInfo = false;
          state.menu = false;
          state.orderSummary = false;
          state.orderDetailsPage = false;
          state.tracking = false;
          state.addressForm = false;
          state.location = false;
          state.isEditUserDetail = false;
          state.dishBook = false;
          state.orderReviewWrite = false;
          state.legalView = false;
          state.cart = false;
          state.chef = false;
          state.dishes = false;
          state.dishMenuCategoryCardDetails = false;
          state.profile = false;
          state.explore = false;
          state.faq = false;
          state.about = false;
          state.storie = false;
          state.account = false;
          state.dishclick = false;
          state.checkout = false;
          state.isOrderSucessfull = false;
          state.benefits = false;
          state.bottombardisplay = true;
          state.address = false;
          state.locationSelector = false;
          state.helpChatScreen = false;
          state.chefListScreen = true;
          state.hostScreen = false;
          break;

        case "hostScreen":
          state.bannerInfo = false;
          state.menu = false;
          state.orderSummary = false;
          state.orderDetailsPage = false;
          state.tracking = false;
          state.addressForm = false;
          state.location = false;
          state.isEditUserDetail = false;
          state.dishBook = false;
          state.orderReviewWrite = false;
          state.legalView = false;
          state.cart = false;
          state.chef = false;
          state.dishes = false;
          state.dishMenuCategoryCardDetails = false;
          state.profile = false;
          state.explore = false;
          state.faq = false;
          state.about = false;
          state.storie = false;
          state.account = false;
          state.dishclick = false;
          state.checkout = false;
          state.isOrderSucessfull = false;
          state.benefits = false;
          state.bottombardisplay = true;
          state.address = false;
          state.locationSelector = false;
          state.helpChatScreen = false;
          state.chefListScreen = false;
          state.hostScreen = true;
          break;

        default:
          break;
      }
    },
    changeBottombar(state, action) {
      state.bottombardisplay = action.payload.bottombardisplay;
      return state;
    },
    updateFrom(state, action) {
      state.from = action.payload.from;
      return state;
    },
    hideCart(state, action) {
      state.cart = false;
      return state;
    },
    hideMenu(state, action) {
      state.menu = false;
      return state;
    },
    showCart(state, action) {
      state.cart = true;
      return state;
    },
    showChef(state) {
      state.chef = true;
      state.account = false;
      return state;
    },
    showAccount(state) {
      state.account = true;
      state.chef = false;
      return state;
    },
    showExplore(state) {
      state.explore = true;
      state.chef = false;
      return state;
    },
  },
});

export const bottomBarActions = bottomBarSlice.actions;

export default bottomBarSlice;
